import { PlusIcon } from '@heroicons/react/24/outline';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import FieldsetContainer from '@/components/shared/FieldsetContainer';
import { Button } from '@/components/ui/daisy';
import useFormList from '@/data/hook/shared/useFormList';
import { CourseFormFields } from './CourseForm';
import PedContentInlineForm from './PedContentInlineForm';

type PedContentFormListProps = {
  onSubmit: (data: CourseFormFields) => Promise<unknown>;
  isLoading: boolean;
};

export default function PedContentFormList({
  onSubmit,
  isLoading,
}: PedContentFormListProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.pedContentTab',
  });
  const { openForms, addForm, removeForm, handleFormSubmit } =
    useFormList<CourseFormFields>({ onSubmit });

  return (
    <Fragment>
      {openForms.map(formId => (
        <PedContentInlineForm
          key={formId}
          onSubmit={handleFormSubmit(formId)}
          onCancel={() => removeForm(formId)}
          isLoading={isLoading}
        />
      ))}
      <FieldsetContainer>
        <Button size="md" onClick={addForm} className="bg-base-300">
          <PlusIcon className="w-4 h-4" />
          {t('addPedContent')}
        </Button>
      </FieldsetContainer>
    </Fragment>
  );
}
